import { z } from 'zod'

export const UsernameSchema = z
	.string({ required_error: 'مطلوب' })
	.min(3, { message: 'طول اسم المستخدم 3 على الاقل' })
	.max(20, { message: 'لا يمكن ان يزيد طول اسم المستخدم عن 20' })
	.regex(/^[\u0621-\u064Aa-zA-Z0-9_]+$/, {
		message: 'اسم المستخدم يمكن ان يحتوي فقط على احرف, ارقام, وشرطة تحتية',
	})
	// users can type the username in any case, but we store it in lowercase
	.transform(value => value.toLowerCase())

export const PasswordSchema = z
	.string({ required_error: 'مطلوب' })
	.min(6, { message: 'طول كلمة المرور 6 على الاقل' })
	.max(100, { message: 'لا يمكن ان يزيد طول كلمة المرور عن 100' })
export const NameSchema = z
	.string({ required_error: 'مطلوب' })
	.min(3, { message: 'طول الاسم 3 على الاقل' })
	.max(40, { message: 'لا يمكن ان يزيد طول الاسم عن 40' })
export const EmailSchema = z
	.string({ required_error: 'مطلوب' })
	.email({ message: 'غير صالح' })
	.min(3, { message: 'طول البريد الالكتروني 3 على الاقل' })
	.max(100, { message: 'لا يمكن ان يزيد طول البريد الالكتروني عن 100' })
	// users can type the email in any case, but we store it in lowercase
	.transform(value => value.toLowerCase())

export const PasswordAndConfirmPasswordSchema = z
	.object({ password: PasswordSchema, confirmPassword: PasswordSchema })
	.superRefine(({ confirmPassword, password }, ctx) => {
		if (confirmPassword !== password) {
			ctx.addIssue({
				path: ['confirmPassword'],
				code: 'custom',
				message: 'كلمات المرور يجب ان تتطابق',
			})
		}
	})
